const Partners = () => {
	return (
		<section className="flex flex-col items-center justify-center pb-8 lg:pb-16">
			<div className="flex flex-row items-center justify-center">
				<span className="mb-6 text-base text-gray-DEFAULT-400 lg:text-xl">Trusted & Integrated with</span>
			</div>

			<div className="container-lp mx-auto flex flex-wrap items-center justify-center overflow-hidden">
				<div className="carousel-container-lp-clients carousel-fade-clients">
					<div className="carousel-clients flex items-center space-x-16">
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo1.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo2.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo3.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo4.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo5.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo6.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo1.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo2.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo3.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo4.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo5.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo6.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo1.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo2.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo3.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo4.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo5.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo6.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo1.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo2.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo3.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo4.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo5.svg"
							width="85"
							height="85"
						/>
						<img
							alt="PagePilot.ai Partner Logo"
							loading="eager"
							className="w-full max-w-[85px]"
							decoding="async"
							data-nimg="1"
							src="/images/landingpage/partnerLogo6.svg"
							width="85"
							height="85"
						/>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Partners;
